module.exports = __webpack_public_path__ + "img/manual-enem.97a67d69.png";